import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ApiService } from "src/app/shared/services/api.service";
import { IApiResponseForArray } from "../interfaces/instance.interface";

@Injectable({
  providedIn: "root",
})
export class InstanceService {
  constructor(private api: ApiService) {}

  /**
   * Get all roles with their groups and allowed functionalities.
   * @param roleType Optional role type filter
   */
  public getRolesWithPermissions(roleType?: string): Observable<IApiResponseForArray> {
    const url = roleType ? `instance/roles-with-permissions?roleType=${encodeURIComponent(roleType)}` : "instance/roles-with-permissions";

    return this.api.get(url) as Observable<IApiResponseForArray>;
  }
}
